import { Link } from "react-router-dom";

const BADGE_CATEGORIES = [
  {
    name: "Practice Streaks",
    icon: "🔥",
    badges: [
      { id: "streak-7", name: "7-Day Seeker", desc: "7 consecutive days of practice", earned: false, icon: "🔥" },
      { id: "streak-30", name: "30-Day Devotee", desc: "30 consecutive days of practice", earned: false, icon: "🔥" },
      { id: "streak-100", name: "Century Yogi", desc: "100 consecutive days", earned: false, icon: "🔥", rarity: "rare" },
      { id: "streak-365", name: "Year of Aekam", desc: "365 consecutive days", earned: false, icon: "🔥", rarity: "legendary" },
    ],
  },
  {
    name: "Wisdom Milestones",
    icon: "📚",
    badges: [
      { id: "wisdom-10", name: "First Teachings", desc: "Read 10 wisdom articles", earned: false, icon: "📖" },
      { id: "wisdom-50", name: "Student of Truth", desc: "Read 50 articles", earned: false, icon: "📚" },
      { id: "wisdom-100", name: "Wisdom Keeper", desc: "Read 100 articles", earned: false, icon: "📜", rarity: "rare" },
    ],
  },
  {
    name: "Community Engagement",
    icon: "🌍",
    badges: [
      { id: "first-event", name: "First Satsang", desc: "Attended your first event", earned: false, icon: "🎟️" },
      { id: "volunteer", name: "Seva Warrior", desc: "Completed a volunteer role", earned: false, icon: "🤝" },
      { id: "donated", name: "Sacred Giver", desc: "Made your first donation", earned: false, icon: "💛" },
    ],
  },
  {
    name: "Healing Journey",
    icon: "🔮",
    badges: [
      { id: "healing-session", name: "Healing Seeker", desc: "Attended a Hanuman Healing session", earned: false, icon: "🔮", rarity: "epic" },
      { id: "dream-journal-10", name: "Dream Keeper", desc: "Logged 10 dream entries", earned: false, icon: "🌙" },
    ],
  },
];

const RARITY_COLORS: Record<string, string> = {
  common: "var(--c-ink-75)",
  rare: "#3b82f6",
  epic: "#9333ea",
  legendary: "#f59e0b",
};

export function BadgesPage() {
  const totalBadges = BADGE_CATEGORIES.flatMap((c) => c.badges).length;
  const earnedBadges = BADGE_CATEGORIES.flatMap((c) => c.badges).filter((b) => b.earned).length;

  return (
    <>
      <section className="page-hero page-hero--brand">
        <div className="container">
          <p className="eyebrow">Achievements</p>
          <h1 className="display-2">Badge Vault</h1>
          <p className="hero__body" style={{ maxWidth: "540px", margin: "0 auto" }}>
            Earn badges by deepening your practice, exploring wisdom, and engaging with the community.
          </p>
        </div>
      </section>

      {/* Progress overview */}
      <section className="section section--tight" style={{ background: "var(--c-surface-alt)" }}>
        <div className="container">
          <div className="badges-overview">
            <div className="badges-overview__stat">
              <span className="badges-overview__value">{earnedBadges}</span>
              <span className="badges-overview__label">Earned</span>
            </div>
            <div className="badges-overview__stat">
              <span className="badges-overview__value">{totalBadges - earnedBadges}</span>
              <span className="badges-overview__label">Locked</span>
            </div>
            <div className="badges-overview__stat">
              <span className="badges-overview__value">{totalBadges}</span>
              <span className="badges-overview__label">Total</span>
            </div>
            <div className="badges-overview__progress">
              <div className="badges-progress-bar">
                <div
                  className="badges-progress-bar__fill"
                  style={{ width: `${totalBadges > 0 ? (earnedBadges / totalBadges) * 100 : 0}%` }}
                />
              </div>
              <p style={{ fontSize: "0.8rem", color: "var(--c-ink-75)", marginTop: "0.3rem" }}>
                {totalBadges > 0 ? Math.round((earnedBadges / totalBadges) * 100) : 0}% complete
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Badge categories */}
      <section className="section">
        <div className="container">
          {BADGE_CATEGORIES.map((cat) => (
            <div key={cat.name} className="badges-category">
              <h2 className="badges-category__title">
                <span>{cat.icon}</span> {cat.name}
              </h2>
              <div className="badges-grid">
                {cat.badges.map((badge) => (
                  <div
                    key={badge.id}
                    className={`badge-card ${badge.earned ? "badge-card--earned" : "badge-card--locked"}`}
                  >
                    <div
                      className="badge-card__icon"
                      style={{ color: badge.rarity ? RARITY_COLORS[badge.rarity] : undefined }}
                    >
                      {badge.earned ? badge.icon : "🔒"}
                    </div>
                    <div className="badge-card__name">{badge.name}</div>
                    <div className="badge-card__desc">{badge.desc}</div>
                    {badge.rarity && (
                      <div
                        className="badge-card__rarity"
                        style={{ color: RARITY_COLORS[badge.rarity] }}
                      >
                        {badge.rarity}
                      </div>
                    )}
                    {badge.earned && (
                      <div className="badge-card__earned-mark">✓ Earned</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="section--cta">
        <div className="container" style={{ textAlign: "center" }}>
          <h2>Ready to earn more?</h2>
          <p className="text-muted">Start your daily practice to unlock your first badges.</p>
          <Link to="/practice" className="btn btn--brand btn--lg">Begin Practice</Link>
        </div>
      </section>
    </>
  );
}
